import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { ModalLayout, ForwardRefHandlers } from '../ModalLayout';
import SoundSettings from '@/components/Setting/Sound';
import WindowSettings from '@/components/Setting/Window';
import UserSettings from '@/components/Setting/User';
import { SteamUser } from '@/types/user';
import { useAudio } from '@/context/AudioContext';
import ServerSettings from '@/components/Setting/Server';
import { useRouter } from 'next/router';

type TabType = 'display' | 'sound' | 'game' | 'server';

interface Props {
  onClose: () => void;
  onChangeName?: (userId: string, name: string) => void;
  onChangeAvatar?: (user: SteamUser) => void;
}

const tabs: { label: string; value: TabType }[] = [
  { label: 'gameSetting', value: 'game' },
  { label: 'soundSetting', value: 'sound' },
];

export default function SettingModal({
  onClose,
  onChangeName,
  onChangeAvatar,
}: Props) {
  const { playSoundEffect } = useAudio();

  const { t, i18n } = useTranslation();
  const ref = React.useRef<ForwardRefHandlers>(null);
  const [tabType, setTabType] = React.useState<TabType>('game');

  const handleChangeTab = (tabType: TabType) => () => {
    playSoundEffect('click_button');
    setTabType(tabType);
  };

  return (
    <ModalLayout className="!h-auto" ref={ref} onClose={onClose}>
      <div className="modal-content">
        <div className="p-3 py-6 h-full flex flex-col justify-center s:py-4 s:px-2 se-h:py-4 se-h:px-2">
          <div className="grid grid-cols-2 gap-8 mb-4">
            {tabs.map((tab) => (
              <div
                key={tab.value}
                className={`text-2xl font-bold cursor-pointer relative text-center s:text-xs se-h:text-xs xs:text-base ${
                  tabType === tab.value ? 'text-brown-primary' : 'text-gray-400'
                } hover:text-brown-primary hover:opacity-90`}
                style={{ backgroundSize: '100% 180%' }}
                onClick={handleChangeTab(tab.value)}
              >
                <span>{t(tab.label)}</span>
              </div>
            ))}
          </div>
          <div className="h-[480px] text-brown-primary">
            {tabType === 'game' && (
              <UserSettings
                onChangeName={onChangeName}
                onChangeAvatar={onChangeAvatar}
              />
            )}
            {tabType === 'sound' && <SoundSettings />}

            {tabType === 'server' && <ServerSettings />}
          </div>
        </div>
      </div>
    </ModalLayout>
  );
}
